import { FunctionComponent } from 'react';

// components
import { PriceAmount, PriceAmountProps } from './PriceAmount';

interface Props extends PriceAmountProps {
    price?: number;
    originalPrice?: number;
    percentageOff?: number;
}

/**
 * Price Components for an item on sale
 *  (Sale or Sale & Original)
 */
export const SaleItemPrices: FunctionComponent<Props> = ({
    price,
    originalPrice,
    currency,
    percentageOff,
    quantityDisplay,
    hasPrivateOffer,
    appendElementToPrice,
    displayVatLabel,
}) => (
    <>
        {/* SALE PRICE */}
        <PriceAmount
            type="SALE"
            currency={currency}
            amount={price}
            quantityDisplay={quantityDisplay}
            appendElementToPrice={appendElementToPrice}
            displayVatLabel={displayVatLabel}
        />
        {/* ORIGINAL PRICE */}
        {!!originalPrice && (
            <PriceAmount
                hasSalePrice
                discount={percentageOff}
                currency={currency}
                amount={originalPrice}
                quantityDisplay={quantityDisplay}
                hasPrivateOffer={hasPrivateOffer}
            />
        )}
    </>
);
